<template>
  <action-modal :is-open="true" @close="close">
    <span slot="title">{{ title }}</span>
    <v-layout wrap mt-4>
      <v-flex xs12 md8 pl-2 pr-2>
        <v-text-field
          label="Address name"
          outlined
          v-model="updatedAddress.name"
          dense
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout wrap mb-4>
      <v-flex xs12 md8 pl-2 pr-2>
        <address-lookup
          @select_address="setSelectedAddress"
          :currentAddress="updatedAddress.formatted_address"
        />
      </v-flex>
    </v-layout>
    <div v-if="address.meta && address.meta.distributorSettings">
      <v-layout>
        <v-flex xs12 md8 pa-2>
          When an order is created for this address, email:
          <email-selector
            :selected-emails.sync="orderEmailAlerts"
            :email-index="0"
            :options="options.orderCreated"
            multiple
            event="order-created"
            pricing-option
          />
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md8 pa-2>
          When an order status is updated, email:
          <email-selector
            :selected-emails.sync="orderStatusAlerts"
            :email-index="0"
            :options="options.orderStatusUpdated"
            multiple
            event="order-status-updated"
            :pricing-option="false"
          />
        </v-flex>
      </v-layout>
      <v-divider />
      <v-layout v-if="distributors">
        <set-distributors
          :distributorSettings.sync="address.meta.distributorSettings"
          :distributors="distributors"
        />
      </v-layout>
    </div>
    <div slot="actions">
      <v-layout>
        <v-btn
          :disabled="!validAddress"
          @click="$emit('save', updatedAddress)"
          color="primary"
          >Save</v-btn
        >
      </v-layout>
    </div>
  </action-modal>
</template>

<script>
import ActionModal from "./ActionModal";
import SetDistributors from "../../../pages/associate/customers/SetDistributors";
import EmailSelector from "@/components/shared/EmailSelector";
import { get } from "lodash";
import AddressLookup from "@/components/shared/AddressLookup";

export default {
  name: "AddressModal",
  created() {
    this.initializeEmailSettings();
  },
  props: {
    address: {
      type: Object,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    distributors: {
      type: Array,
    },
    options: {
      type: Object,
      default: () => {
        return {
          orderCreated: [],
          orderStatusUpdated: [],
        };
      },
    },
  },
  data() {
    return {
      orderStatusAlerts: [],
      orderEmailAlerts: [],
    };
  },
  components: {
    ActionModal,
    SetDistributors,
    EmailSelector,
    AddressLookup,
  },
  computed: {
    updatedAddress() {
      const { address, orderStatusAlerts, orderEmailAlerts } = this;
      if (address.meta && address.meta.emailSettings) {
        address.meta.emailSettings = [
          ...orderStatusAlerts,
          ...orderEmailAlerts,
        ];
      }

      return address;
    },
    open() {
      return this.isOpen;
    },
    validAddress() {
      const { meta, formatted_address } = this.updatedAddress;
      if (meta && meta.emailSettings) {
        return formatted_address;
      } else {
        return formatted_address;
      }
    },
  },
  methods: {
    setSelectedAddress(address) {
      const { formatted_address, address1, city, state, zip } = address;
      Object.assign(this.updatedAddress, {
        formatted_address,
        address1,
        city,
        state,
        zip,
      });
    },
    initializeEmailSettings() {
      if (this.address.meta && this.address.meta.emailSettings) {
        const { emailSettings } = get(this, "address.meta", []);
        if (emailSettings.length) {
          this.orderStatusAlerts = emailSettings.filter((email) => {
            return email.event === "order-status-updated";
          });
          this.orderEmailAlerts = emailSettings.filter((email) => {
            return email.event === "order-created";
          });
        }
      }
    },
    close() {
      this.$emit("update:addressModal", false);
    },
  },
};
</script>
